export const PET_CHANGE_REQUEST_STATUS = {
  pending: 'pending',
  approved: 'approved',
  rejected: 'rejected',
  cancelled: 'cancelled',
} as const;

export type PetChangeRequestStatus =
  (typeof PET_CHANGE_REQUEST_STATUS)[keyof typeof PET_CHANGE_REQUEST_STATUS];
